import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/marketing/social-content")({
  component: () => <Outlet />,
});
